import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import queryJobsById from '../services/job/query.jobs.by.id';

// THUNKS
export const searchJobsByJobId = createAsyncThunk('jobssearch/searchJobsByJobId', queryJobsById.handler);
// export const fetchJobServiceDetails = createAsyncThunk('jobs/fetchJobServiceDetails', getJobService.handler);
// export const fetchJobServiceReports = createAsyncThunk('jobs/fetchJobServiceReports', getJobReports.handler);

const initial_state = {
  loading: false,
  items: [],
  next_token: null,
};

// slice definition
const slice = createSlice({
  name: 'jobs',
  initialState: initial_state,
  reducers: {
    resetJobSearch: (state) => {
      return initial_state;
    }
  },
  extraReducers: builder => {
    builder

      // searchJobsByJobId
      .addCase(searchJobsByJobId.pending, queryJobsById.pending)
      .addCase(searchJobsByJobId.fulfilled, queryJobsById.fulfilled)
      .addCase(searchJobsByJobId.rejected, queryJobsById.rejected)
  },
});

export const { resetJobSearch } = slice.actions;
const { reducer } = slice;
export default reducer;